module.exports = __webpack_public_path__ + "img/logo.5ac891a5.png";